<template>
  <div class="pagination-container">
    <el-pagination
      @current-change="handleChange"
      :current-page="current"
      :page-size="pageSize"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
// <my-pagination :total="total" :pageSize.sync="pageSize" :current="current" @changePage="changePage"/>
export default {
  name: 'webPagination',
  props: {
    total: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    current: {
      // 当前页
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      value: false,
    }
  },
	created() {
    // debugger
		console.log(this.total)
	},
  methods: {
    handleChange(value) {
      this.$emit('changePagen', value)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // this.$emit('update:pageSize', val)
      this.$emit('pageSizen', val)
    },
  },
}
</script>

/* .pagination-container{
  box-sizing: border-box;
  text-align:center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-pager li.active {
  font-family: SFProText-Medium;
  color: #fff !important;
  font-weight: 600;
  background-color: #d91e1c;
  border: .0069rem solid #d91e1c !important;
  margin-right: .0278rem;
  font-size: .0972rem;
}
.el-pager li {
  font-size: .0972rem;
  border: .0069rem solid #d7d7d7 !important;
  margin-left: .0278rem;
  margin-right: .0278rem;
}
.el-pager li:hover{
  font-size: .0972rem;
  border: .0069rem solid #d91e1c;
  border: .0069rem solid #d91e1c !important;
  color: #d91e1c;
}
.el-pagination button {
  border: .0069rem solid #d7d7d7;
}
.el-pagination button:hover {
    color: #d91e1c;
    border: .0069rem solid #d91e1c;
}
.el-select .el-input.is-focus .el-input__inner {
    border-color: #d91e1c;
    border: .0069rem solid #d91e1c;
}
.el-select-dropdown__item.selected {
    color: #d91e1c;
    font-weight: 700;
}
.el-select .el-input__inner:focus {
    border-color: #d9d9d9;
}
.el-select .el-input__inner:hover{
  border: .0069rem solid #d91e1c !important;
}

.el-pagination__editor.el-input .el-input__inner:focus{
  border: .0069rem solid #d91e1c !important;
}
.el-pagination__editor.el-input .el-input__inner:hover{
  border: .0069rem solid #d91e1c !important;
} */



<style lang="less" scoped>
.pagination-container {
  margin-top: 0.2292rem;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  .el-pagination {
    text-align: right;
    // margin: 33px 0 24px;
    /deep/ .el-pager li.active {
      font-family: SFProText-Medium;
      color: #fff !important;
      font-weight: 600;
      background-color: #5f8def;
      border: 0.0069rem solid #5f8def !important;
      margin-right: 0.0278rem;
      font-size: 0.0972rem;
    }
    /deep/ .el-pager li {
      font-size: 0.0972rem;
      border: 0.0069rem solid #d7d7d7 !important;
      margin-left: 0.0278rem;
      margin-right: 0.0278rem;
    }
    /deep/ .el-pager li:hover {
      font-size: 0.0972rem;
      border: 0.0069rem solid #5f8def;
      border: 0.0069rem solid #5f8def !important;
      color: #5f8def;
    }
    /deep/ .el-select .el-input.is-focus .el-input__inner{
      border:.0069rem solid #5f8def;
    }
    /deep/ .el-pagination__sizes .el-input .el-input__inner:hover{
      border:.0069rem solid #5f8def;
      // background-color: #d91e1c;
    }
    /deep/ .el-icon-arrow-right:before:hover{
      color: #5f8def;
      background-color: #5f8def;
    }
    /deep/ .hover{
      color: #5f8def;
    }
  }
  /deep/ .el-pagination .button:hover{
      color: #5f8def;
    }
  
}
</style>


// WEBPACK FOOTER //
// src/components/paginationTwo.vue